import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { CoreModule } from '@app/core/core.module';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { IonicModule } from '@ionic/angular';
import { TranslocoPipe } from '@jsverse/transloco';
import { MaskitoDirective } from '@maskito/angular';
import { NgOtpInputModule } from 'ng-otp-input';
import { NgxIntlTelInputModule } from 'ngx-intl-tel-input-gg';
import { CheckboxComponent } from '../shared/components/form/checkbox/checkbox.component';
import { RadioComponent } from '../shared/components/form/radio/radio.component';
import { EmergencyContactModalComponent } from './components/form/emergency-contact/emergency-contact-modal/emergency-contact-modal.component';
import { EmergencyContactComponent } from './components/form/emergency-contact/emergency-contact.component';
import { InputComponent } from './components/form/input/input.component';
import { MyCompanyInfoComponent } from './components/form/my-company-info/my-company-info.component';
import { MyEmergencyContactComponent } from './components/form/my-profile/my-emergency-contact/my-emergency-contact.component';
import { PhoneComponent } from './components/form/phone/phone.component';
import { SelectModalComponent } from './components/form/select-modal/select-modal.component';
import { SelectComponent } from './components/form/select/select.component';
import { TextareaComponent } from './components/form/textarea/textarea.component';
import { ToggleComponent } from './components/form/toggle/toggle.component';
import { IconComponent } from './components/icon/icon.component';
import { LanguageItemComponent } from './components/language-item/language-item.component';
import { LanguagePickerModalComponent } from './components/language-picker-modal/language-picker-modal.component';
import { LanguageComponent } from './components/language/language.component';
import { RateApplicationModalComponent } from './components/rate-application-modal/rate-application-modal.component';
import { RateWeekModalComponent } from './components/rate-week-modal/rate-week-modal.component';
import { SkipWarningComponent } from './components/skip-warning/skip-warning.component';
import { SpinnerComponent } from './components/spinner/spinner.component';
import { TutorialStepComponent } from './components/upload-tutorial/components/tutorial-step.component';
import { UploadTutorialModalComponent } from './components/upload-tutorial/upload-tutorial-modal.component';
import { ValidationErrorComponent } from './components/validation-error/validation-error.component';
import { WizardHeaderComponent } from './components/wizard/wizard-header/wizard-header.component';
import { WizardStepComponent } from './components/wizard/wizard-step/wizard-step.component';
import { WizardComponent } from './components/wizard/wizard.component';
import { FormatDatePipe } from './pipes/format-date.pipe';
import { ButtonComponent } from './ui/button/button.component';
import { FORM_FIELD } from './ui/form-field/form-field';
import { LabelValueComponent } from './ui/label-value/label-value.component';

const sharedModules: any[] = [
  CommonModule,
  FormsModule,
  IonicModule,
  ReactiveFormsModule,
  FontAwesomeModule,
  NgOtpInputModule,
  NgxIntlTelInputModule,
];

const sharedComponents: any[] = [
  LanguageComponent,
  SpinnerComponent,
  InputComponent,
  SelectComponent,
  TextareaComponent,
  ToggleComponent,
  CheckboxComponent,
  WizardComponent,
  WizardHeaderComponent,
  WizardStepComponent,
  RadioComponent,
  PhoneComponent,
  EmergencyContactComponent,
  EmergencyContactModalComponent,
  MyEmergencyContactComponent,
  LanguagePickerModalComponent,
  LanguageItemComponent,
  SelectModalComponent,
  RateWeekModalComponent,
  SkipWarningComponent,
  RateApplicationModalComponent,
  MyCompanyInfoComponent,
  UploadTutorialModalComponent,
  TutorialStepComponent,
];

const SHAREDPIPES = [FormatDatePipe];

const sharedDirectives = [MaskitoDirective];

@NgModule({
  imports: [
    ...sharedModules,
    ...sharedDirectives,
    CoreModule,
    TranslocoPipe,
    IconComponent,
    ButtonComponent,
    ValidationErrorComponent,
    FORM_FIELD,
    LabelValueComponent,
  ],
  exports: [...sharedModules, ...SHAREDPIPES, ...sharedComponents, IconComponent, ValidationErrorComponent, FORM_FIELD],
  declarations: [...SHAREDPIPES, ...sharedComponents],
  providers: [],
})
export class SharedModule {}
